import { render, staticRenderFns } from "./ListPagination.vue?vue&type=template&id=75322fe6"
import script from "./ListPagination.vue?vue&type=script&lang=ts"
export * from "./ListPagination.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports